import { Directive, Input, OnInit } from '@angular/core';
import { startWith } from 'rxjs';
import { WindowService } from '../../services/window.service';

@Directive({
  selector: '[bsAutomaticTableResizing]',
  exportAs: 'tableResizingInstance',
})
export class AutomaticTableResizingDirective implements OnInit {
  @Input('bsAutomaticTableResizing') displayResize!: Array<string | number>;
  @Input('bsAutomaticTableResizingDisplayColumns')
  displayColumns!: string[];

  autoSizeColumns: string[] = [];
  index!: number;

  constructor(readonly windowService: WindowService) {}

  ngOnInit(): void {
    this.autoSizeColumns = this.displayColumns;
    this.windowService.windowSize$
      .pipe(
        startWith({
          width: window.innerWidth,
        })
      )
      .subscribe(({ width }) => {
        if (!this.displayResize) return;
        if (width >= +this.displayResize[this.displayResize.length - 1]) {
          this.autoSizeColumns = this.displayColumns;
          return;
        }

        this.displayResize.some((size, index) => {
          if (width <= +size) {
            this.index = index + 1;
          }
          return width <= +size;
        });

        this.autoSizeColumns = this.displayColumns.slice(0, this.index);
      });
  }
}
